<script>
  import Th from "../Tables/Th.svelte";
  import ThFilter from "../Tables/ThFilter.svelte";
  import RowsPerPage from "../Tables/RowsPerPage.svelte";
  import RowCount from "../Tables/RowCount.svelte";
  import Pagination from "../Tables/Pagination.svelte";
  import { DataHandler, check, Datatable } from "@vincjo/datatables";
  import {
    selectedDeviceId,
    selectedPage,
    selectedConfigFile,
    uniqueAppIdValuesList,
    uniqueFirmwareValuesList,
    API_DIR,
    SESSION_LS,
    showLoadingModal
  } from "../store";
  import {
    downloadCSV,
    convertCsvToJson,
    convertUnixToDate,
    fileHasChecksum,
    readFileAsByteArray
  } from "../Utils.svelte";
  import { onMount } from "svelte";
  import Select from "svelte-select";
  import { toasts } from "svelte-toasts";

  let responseJsonData = [];
  let selectedFile = null;
  let selectedAppIdeOptions = [];
  let selectedAppId = [];
  let firmwareSelection = [];
  let configTypes = ["LMU", "JPOD", "JPOD2"];
  let configTypeInput = configTypes[0];

  //console.log(responseJsonData);
  let fileInput;
  let handler = new DataHandler(responseJsonData, { rowsPerPage: 15 });
  let rows = handler.getRows();
  let selected = handler.getSelected();
  let isAllSelected = handler.isAllSelected();
  let disabled;
  let allowOverwrite = false;
  let fComment = "";
  let isMounted = false;
  let btnModalClose;
  //let configVersion = "";
  selectedConfigFile.set([]);
  let isFormValid = false;
  let authString = "";

  //$: $selectedDeviceId, console.log($selectedDeviceId); //DeviceDetail
  //$: allowOverwrite, console.log(allowOverwrite); //DeviceDetail
  //$: $selected, console.log($selected);
  $: $selected, switchEnable();

  function checkFormValidity() {
    const missingFields = [];

    if (selectedAppId.length === 0) {
      missingFields.push("App IDs");
    }

    if (firmwareSelection.length === 0) {
      missingFields.push("Compatible FW");
    }

    /*if (configVersion.trim() === "") {
      missingFields.push("Version");
    }*/

    if (fComment.trim() === "") {
      missingFields.push("Comment");
    }

    if (configTypeInput.trim() === "") {
      missingFields.push("ConfigType");
    }

    if (fileInput.files.length === 0) {
      missingFields.push("File");
    }

    //console.log(missingFields);
    isFormValid = missingFields.length === 0;
  }

  async function setUpTable() {
    responseJsonData = await fetchConfigData();
    handler = new DataHandler(responseJsonData, { rowsPerPage: 15 });
    rows = handler.getRows();
    selected = handler.getSelected();
    isAllSelected = handler.isAllSelected();
    disabled = true;
  }

  async function fetchConfigData() {
    try {
      showLoadingModal.set(true);

      const response = await fetch(`${$API_DIR}/api/v1/config-files`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        }
      });
      if (response.status === 401) {
        location.reload();
      }
      if (!response.ok) {
        throw new Error("Error al obtener los archivos de configuración");
      }
      const data = await response.json();
      showLoadingModal.set(false);

      if (data.length > 0) {
        return data;
      } else {
        return [];
      }
    } catch (error) {
      console.log("Error:", error);
      showLoadingModal.set(false);
    }
  }

  async function deleteFiles() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Session-Id": localStorage.getItem($SESSION_LS)
      },
      body: JSON.stringify({
        filenames: $selected
      })
    };

    try {
      showLoadingModal.set(true);

      const response = await fetch(
        `${$API_DIR}/api/v1/delete-config-file`,
        requestOptions
      );

      if (response.ok) {
        const data = await response.json();
        console.log(data.message); // Mensaje de éxito
        toasts.success("Files successfully deleted.");

        await setUpTable();
      } else if (response.status === 401) {
        location.reload();
      } else if (response.status === 409) {
        toasts.error("One or more files are currently in use.");
      } else {
        const errorData = await response.json();
        console.log(errorData.error); // Mensaje de error
      }
      showLoadingModal.set(false);
    } catch (error) {
      console.log("Error en la solicitud al servidor:", error);
      showLoadingModal.set(false);
    }
  }

  function switchEnable() {
    if (isMounted) {
      disabled = $selected.length == 0 ? true : false;
    }
  }

  function truncateText(text = "", limit) {
    const words = text.split(" ");
    if (words.length > limit) {
      const truncatedWords = words.slice(0, limit);
      return truncatedWords.join(" ") + "...";
    }
    return text;
  }

  function toggleButton(row) {
    console.log(row);
    /*row.device_updates =
      row.device_updates === "enabled" ? "disabled" : "enabled";*/
  }

  function checkCSVFormat(event) {
    const fileInput = event.target;
    const file = fileInput.files[0];

    // Verificar si se ha seleccionado un archivo
    if (!file) {
      selectedFile = null;
      alert("No se ha seleccionado ningún archivo.");
      return;
    }

    // Verificar la extensión del archivo
    const allowedExtensions = ["csv"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!allowedExtensions.includes(fileExtension)) {
      fileInput.value = ""; // Limpiar el valor del input file
      selectedFile = null;
      toasts.info("Please select a valid CSV file");
      return;
    }

    // Verificar si el título del archivo contiene caracteres especiales
    const forbiddenChars = /[!@#$%^&*()+=\[\]{};':"\\|,.<>\/?\s]+/;
    const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
    if (forbiddenChars.test(fileNameWithoutExtension)) {
      fileInput.value = ""; // Limpiar el valor del input file
      selectedFile = null;
      toasts.info("File title cannot contain special characters.");
      return;
    }

    selectedFile = file;
    //alert("El archivo es de tipo CSV.");
  }

  /*async function saveFile() {
    const file = fileInput.files[0];

    console.log("Checksum", await fileHasChecksum(file));
  }*/

  async function getScriptAndConfig(jsonContent, type) {
    const data = JSON.parse(jsonContent);
    console.log(data);
    let configValue = null;
    let versionValue = null;

    for (const item of data) {
      let keys = Object.keys(item);
      const parameterId = item[keys[0]];
      const parameterIndex = item[keys[1]];
      const parameterValue = item[keys[2]];

      //console.log(parameterId, parameterIndex, parameterValue);

      if (type == "LMU") {
        if (parameterId == "1024") {
          if (parameterIndex == "1") {
            configValue = parseInt(
              parameterValue.replace("\r", "").replace("0", ""),
              16
            ).toString();
          }

          if (parameterIndex == "23") {
            versionValue = parseInt(
              parameterValue.replace("\r", "").replace("0", ""),
              16
            ).toString();
          }
        }
      } else if (type == "JPOD" || type == "JPOD2") {
        if (parameterId == "5007") {
          if (parameterIndex == "0") {
            configValue = parseInt(
              parameterValue[0].replace("\r", "").replace("0", ""),
              16
            ).toString();
            versionValue = parseInt(
              parameterValue[1].replace("\r", "").replace("0", ""),
              16
            ).toString();
          }
        }
      }
    }

    return {
      config: configValue,
      version: versionValue
    };
  }

  async function saveFile() {
    if (isFormValid) {
      const file = fileInput.files[0];
      const reader = new FileReader();

      const checksumResult = await fileHasChecksum(file);

      //console.log("Checksum", checksumResult);

      if (checksumResult) {
        const byteArray = await readFileAsByteArray(file);
        const byteArrayWithoutLastTwo = byteArray.slice(0, -2);
        const newFile = new Blob([byteArrayWithoutLastTwo], {
          type: file.type
        });

        reader.readAsText(newFile);
      } else {
        reader.readAsText(file);
      }

      reader.onloadend = async function () {
        const csvContent = reader.result;
        const jsonContent = await convertCsvToJson(csvContent);
        // Convertir jsonContent a una cadena JSON válida
        const jsonString = JSON.stringify(jsonContent);
        const scriptAndConfig = await getScriptAndConfig(
          jsonString,
          configTypeInput
        );

        let bodyVersion;

        bodyVersion = `${scriptAndConfig.config} - ${scriptAndConfig.version}`;

        console.log("RESULTS", scriptAndConfig);

        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Session-Id": localStorage.getItem($SESSION_LS)
          },
          body: JSON.stringify({
            allow_overwrite: allowOverwrite,
            version: bodyVersion,
            filename: file.name,
            comment: fComment,
            app_id: selectedAppId,
            compatible_firmware: firmwareSelection,
            type: configTypeInput,
            device_updates: true,
            json_data: jsonContent,
            auth: authString,
            script: scriptAndConfig.version,
            config: scriptAndConfig.config
          })
        };

        try {
          showLoadingModal.set(true);

          const response = await fetch(
            `${$API_DIR}/api/v1/save-config-file`,
            requestOptions
          );
          showLoadingModal.set(false);

          if (response.ok) {
            btnModalClose.click();
            toasts.success("File successfully uploaded.");
            fComment = "";
            //configVersion = "";
            selectedFile = null;
            selectedAppId = [];
            firmwareSelection = [];
            checkFormValidity();
            await setUpTable();
          } else if (response.status === 401) {
            location.reload();
          } else if (response.status === 410) {
            toasts.warning("A file with the same params already exist.");
          } else if (response.status === 409) {
            toasts.warning("File already exist.");
          } else {
            toasts.error("Could not save file.");
          }
        } catch (error) {
          showLoadingModal.set(false);
          toasts.error("Could not save file.");
        }
      };
    }
  }

  function handleFirmwareSelection(e) {
    try {
      firmwareSelection = e.detail.map((obj) => obj.value);
    } catch (error) {
      firmwareSelection = [];
      //console.log(error);
    }
    checkFormValidity();
  }

  function handleAppIdSelection(e) {
    try {
      selectedAppId = e.detail.map((obj) => obj.value);
    } catch (error) {
      selectedAppId = [];
      //console.log(error);
    }
    checkFormValidity();
  }

  onMount(async () => {
    fileInput = document.getElementById("formFileConfig");
    btnModalClose = document.getElementById("btn-modal-close");

    await setUpTable();
    isMounted = true;
  });
</script>

{#if isMounted}
  <hr />
  <div class="row">
    <div class="col-lg-6">
      <h2>Config Files</h2>
    </div>
    <div class="col-lg-6">
      <div class="d-flex justify-content-end">
        <div style="margin-top: 4px;">
          <RowsPerPage {handler} />
        </div>

        <button
          {disabled}
          id="btn-config"
          type="button"
          class="btn btn-danger"
          style="margin-left:16px"
          on:click={deleteFiles}
        >
          <i class="bi bi-trash-fill" /> Delete</button
        >

        <button
          id="btn-config"
          type="button"
          class="btn btn-primary"
          style="margin-left:16px"
          data-bs-toggle="modal"
          data-bs-target="#addConfigModal"
          on:click={() => {}}
        >
          <i class="bi bi-file-earmark-plus-fill" /> Add</button
        >
      </div>
    </div>
  </div>
  <hr />

  <!--<div class="table-responsive">-->
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th class="selection">
              <input
                type="checkbox"
                on:click={() => handler.selectAll({ selectBy: "filename" })}
                checked={$isAllSelected}
              />
            </th>

            {#each Object.keys(responseJsonData[0]) as obj}
              {#if obj != "data" && obj != "company"}
                <Th {handler} orderBy={obj}>{obj.toUpperCase()}</Th>
              {/if}
            {/each}

            <th>EDIT</th>
            <th>EXPORT</th>
          </tr>
          <tr>
            <th class="selection" />

            {#each Object.keys(responseJsonData[0]) as obj}
              {#if obj != "data" && obj != "company"}
                <ThFilter {handler} filterBy={obj} />
              {/if}
            {/each}

            <th class="selection" />
            <th class="selection" />
          </tr>
        </thead>
        <tbody style="table-striped">
          {#each $rows as row}
            <tr class:active={$selected.includes(row.filename)}>
              <td class="selection">
                <input
                  type="checkbox"
                  on:click={() => handler.select(row.filename)}
                  checked={$selected.includes(row.filename)}
                />
              </td>

              {#each Object.keys(responseJsonData[0]) as obj}
                {#if obj === "device_updates"}
                  <td align="center" style="white-space: nowrap">
                    <div>
                      {#if row.device_updates == true}
                        <button
                          type="button"
                          class="btn btn-success"
                          on:click={() => toggleButton(row)}
                        >
                          ENABLED
                        </button>
                      {:else}
                        <button
                          type="button"
                          class="btn btn-secondary"
                          on:click={() => toggleButton(row)}
                        >
                          DISABLED
                        </button>
                      {/if}
                    </div>
                  </td>
                {:else if obj == "type"}
                  <td align="center">
                    {truncateText(row[obj.toString()], 5)}
                  </td>
                {:else if obj == "comment"}
                  <td align="center">
                    {truncateText(row[obj.toString()], 5)}
                  </td>
                {:else if obj == "creation_date"}
                  <td align="center">
                    {convertUnixToDate(row.creation_date)}
                  </td>
                {:else if obj == "last_modified"}
                  <td align="center">
                    {convertUnixToDate(row.last_modified)}
                  </td>
                {:else if obj == "auth"}
                  <td align="center" style="white-space: nowrap">
                    {#if row[obj.toString()] != ""}
                      <div class="badge bg-success">true</div>
                    {:else}
                      <div class="badge bg-secondary">false</div>
                    {/if}
                  </td>
                {:else if obj == "data"}
                  <!--NOTHING-->
                  {:else if obj == "company"}
                  <!--NOTHING-->
                {:else}
                  <td align="center" style="white-space: nowrap"
                    >{row[obj.toString()]}</td
                  >
                {/if}
              {/each}

              <td align="center" style="white-space: nowrap">
                <button
                  type="button"
                  class="btn btn-primary"
                  on:click={() => {
                    selectedPage.set(6);
                    selectedConfigFile.set(row);
                  }}><i class="bi bi-pen" /></button
                >
              </td>

              <td align="center" style="white-space: nowrap">
                <button
                  type="button"
                  class="btn btn-success"
                  on:click={downloadCSV(row.data, row.filename)}
                  ><i class="bi bi-table" /></button
                >
              </td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>

    <br />
    <div class="row">
      <div class="col d-flex justify-content-end">
        <RowCount {handler} />
        <div style="width: 12px;" />
        <Pagination {handler} />
      </div>
    </div>

    <br />

{/if}

<!--MODAL-->
<!-- Modal -->
<div
  class="modal fade"
  id="addConfigModal"
  tabindex="-1"
  aria-labelledby="addConfigModallLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addConfigModallLabel">Add Config File</h5>
        <button
          id="btn-modal-close"
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div class="modal-body">
        <div class="input-group mb-3 row" style="margin-left: inherit;">
          <span class="input-group-text col" style="max-width: fit-content;"
            >App ID</span
          >
          <Select
            id="AppIdSelectionInput"
            class="col"
            items={$uniqueAppIdValuesList}
            value={selectedAppId}
            placeholder="Selecciona una o más opciones"
            selected={selectedAppId}
            multiple
            on:input={handleAppIdSelection}
          />
        </div>

        <div class="input-group mb-3 row" style="margin-left: inherit;">
          <span class="input-group-text col" style="max-width: fit-content;"
            >Compatible FW</span
          >
          <Select
            id="firmwareSelectionInput"
            class="col"
            items={$uniqueFirmwareValuesList}
            value={firmwareSelection}
            placeholder="Selecciona una o más opciones"
            selected={firmwareSelection}
            multiple
            on:input={handleFirmwareSelection}
          />
        </div>

        <div class="input-group mb-3">
          <span class="input-group-text">Config Type</span>

          <select
            class="form-select"
            id="platformSelectionInput"
            bind:value={configTypeInput}
            on:change={() => {
              checkFormValidity();
            }}
          >
            {#each configTypes as option}
              <option value={option}>
                {option}
              </option>
            {/each}
          </select>
        </div>

        <!--<div class="input-group mb-3">
          <span class="input-group-text">Version</span>
          <input
            bind:value={configVersion}
            on:input={() => {
              checkFormValidity();
            }}
            type="text"
            class="form-control"
            placeholder="Version"
            aria-describedby="basic-addon1"
          />
        </div>-->

        <div class="input-group">
          <span class="input-group-text">Comment</span>
          <textarea
            id="fileCommentInput"
            class="form-control"
            placeholder="Agrega un commentario"
            bind:value={fComment}
            on:input={() => {
              checkFormValidity();
            }}
          />
        </div>

        <hr />

        <div class="mb-3">
          <input
            class="form-control"
            type="file"
            id="formFileConfig"
            accept=".csv"
            on:change={(event) => {
              checkCSVFormat(event);
              fileInput = event.target;
              if (fileInput.files && fileInput.files.length > 0) {
                //selectedFile = fileInput.files[0];
                checkFormValidity();
              } else {
                //selectedFile = null;
                checkFormValidity();
              }
            }}
          />
        </div>

        <hr />
        <div class="input-group">
          <span class="input-group-text">Auth</span>
          <input
            type="text"
            class="form-control"
            placeholder="Auth String (optional)"
            aria-describedby="basic-addon1"
            bind:value={authString}
          />
        </div>
        <hr />

        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
            bind:checked={allowOverwrite}
          />
          <label class="form-check-label" for="flexCheckDefault">
            Allow Overwrite
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          >Close</button
        >
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-success"
            on:click={saveFile}
            disabled={!isFormValid}
            ><i class="bi bi-table" /> Upload file</button
          >
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  thead th.selection {
    width: 48px;
    padding-left: 24px;
  }
  tbody tr {
    transition: all, 0.2s;
  }

  td.selection {
    padding-left: 24px;
  }
</style>
